import { COMPLETED_ORDER_STATUSES } from '@constants/order';
import { Order } from '@customTypes/order';

export const isOrderReported = (order: Order): boolean => {
  return COMPLETED_ORDER_STATUSES.includes(order.status);
};
